import { render, staticRenderFns } from "./DashboardIsfpPsfpHeatmapTendencia.vue?vue&type=template&id=3e2a7cd1&scoped=true&"
import script from "./DashboardIsfpPsfpHeatmapTendencia.vue?vue&type=script&lang=js&"
export * from "./DashboardIsfpPsfpHeatmapTendencia.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIsfpPsfpHeatmapTendencia.vue?vue&type=style&index=0&id=3e2a7cd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a7cd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VProgressCircular,VSimpleTable,VTooltip})
